import Cropper from "react-easy-crop";
import { useState } from "react";
import { Col, Modal, ModalBody, ModalFooter, Row } from "react-bootstrap";

import Icon from "./Icon";
import { convertDataURLtoFile } from "../utils";
import { hostname } from "../services/configServices/config";

const AvatarCropper = ({
  value,
  onChange,
  onRemove,
  base64,
  isEditMode = true,
}) => {
  const [image, setImage] = useState("");
  const [fileName, setFileName] = useState("");
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedArea, setCroppedArea] = useState(null);

  // Handle the change event when a file is selected
  const handleOnChange = (file) => {
    if (file) {
      setFileName(file.name);
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        onImageSelected(reader.result);
      };
    }
    document.getElementById(`upload-avatar`).value = "";
  };
  // Callback function when an image is selected
  const onImageSelected = (selectedImg) => {
    setImage(selectedImg);
  };

  // Callback when cropping is completed
  const onCropComplete = (croppedAreaPercentage, croppedAreaPixels) => {
    // Store the cropped area in pixels
    setCroppedArea(croppedAreaPixels);
  };

  // Callback function when cropping is done
  const onCropDone = (imgCroppedArea) => {
    // Create a canvas element to crop the image
    const canvasEle = document.createElement("canvas");
    canvasEle.width = imgCroppedArea.width;
    canvasEle.height = imgCroppedArea.height;

    const context = canvasEle.getContext("2d");

    // Load the selected image
    let imageObj1 = new Image();
    imageObj1.src = image;

    imageObj1.onload = () => {
      // Draw the cropped portion of the image onto the canvas
      context.drawImage(
        imageObj1,
        imgCroppedArea.x,
        imgCroppedArea.y,
        imgCroppedArea.width,
        imgCroppedArea.height,
        0,
        0,
        imgCroppedArea.width,
        imgCroppedArea.height,
      );

      // Convert the canvas content to a data URL (JPEG format)
      const dataURL = canvasEle.toDataURL("image/jpeg");

      if (base64) {
        onChange(base64);
      } else {
        onChange(convertDataURLtoFile(dataURL, fileName));
      }
    };

    onCropReset();
  };

  const onCropReset = () => {
    setImage("");
    setFileName("");
  };

  return (
    <>
      <div className="d-flex justify-content-center align-items-center mb-3">
        <div className="position-relative">
          {value && isEditMode && (
            <span
              className="w-40-px h-40-px bg-danger-600 rounded-circle d-flex justify-content-center align-items-center position-absolute"
              style={{ left: 0, top: 0 }}
              onClick={onRemove}
            >
              <Icon
                icon="solar:trash-bin-minimalistic-broken"
                className="text-white text-xl"
              />
            </span>
          )}
          <label
            htmlFor="upload-avatar"
            className="p-1 rounded-circle d-flex justify-content-center align-items-center"
            style={{
              width: 150,
              height: 150,
              border: "4px solid #ddd",
            }}
          >
            {value ? (
              <img
                className="img-fluid rounded-circle"
                alt=""
                src={`${hostname}${value}`}
              />
            ) : (
              <Icon icon="solar:camera-outline" className="text-xl" />
            )}
            {isEditMode && (
              <input
                type="file"
                id="upload-avatar"
                className="d-none"
                accept="image/,.jpg,.jpeg,.png;capture=camera"
                onChange={(e) => {
                  const file = e.target.files[0];
                  handleOnChange(file);
                }}
              />
            )}
          </label>
        </div>
      </div>

      <Modal show={image} className="modal-dialog-centered" size="md">
        <input
          type="range"
          min="1"
          max="5"
          step="0.05"
          className="form-control border-0"
          value={zoom}
          onChange={(e) => setZoom(+e.target.value)}
        />
        <ModalBody>
          <div style={{ height: 300 }}>
            <Cropper
              image={image}
              aspect={1 / 1}
              crop={crop}
              zoom={zoom}
              onCropChange={setCrop}
              onZoomChange={setZoom}
              onCropComplete={onCropComplete}
              style={{
                containerStyle: {
                  width: "100%",
                  height: "100%",
                },
              }}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="w-100">
            <Row className="align-items-center justify-content-between">
              <Col>
                <button
                  type="button"
                  onClick={onCropReset}
                  className="border border-danger-600 bg-danger-50 bg-hover-danger-100 text-danger-600 text-md w-100 text-center py-8 radius-8"
                >
                  انصراف
                </button>
              </Col>
              <Col>
                <button
                  className="border border-primary-600 bg-primary bg-hover-primary-600 text-white text-md w-100 text-center py-8 radius-8"
                  type="submit"
                  onClick={() => onCropDone(croppedArea)}
                >
                  برش و ثبت
                </button>
              </Col>
            </Row>
          </div>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default AvatarCropper;
